var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.model.options, function(type) {
        return _c(
          "div",
          { key: type.id, staticClass: "mb-4" },
          [
            _c("section-title", {
              attrs: { content: type.name, "has-line": "" }
            }),
            _c(
              "div",
              { staticClass: "mb-3 partial-time" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required|min_value:1" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _vm.getTimeOption(type)
                              ? _c("custom-input", {
                                  attrs: {
                                    "custom-error-msg":
                                      "El campo es requerido y debe ser mayor a 0",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    label: `${_vm.getTimeOption(type)?.name ||
                                      ""}:`,
                                    min: "1",
                                    placeholder: "0",
                                    type: "number"
                                  },
                                  model: {
                                    value: _vm.getTimeOption(type).other,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.getTimeOption(type),
                                        "other",
                                        $$v
                                      )
                                    },
                                    expression: "getTimeOption(type).other"
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.levels, function(level) {
                return _c("div", { key: level, staticClass: "col-md-6 mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "level-card", class: `level-${level}` },
                    [
                      _c("div", { staticClass: "level-card__header" }, [
                        _vm._v("Nivel " + _vm._s(level))
                      ]),
                      _c("validation-provider", {
                        attrs: { rules: "required|min_value:1" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("input", {
                                    attrs: { type: "hidden" },
                                    domProps: {
                                      value: _vm.getLevelValidationValue(
                                        type,
                                        level
                                      )
                                    }
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "level-card__body" },
                                    [
                                      _vm._l(
                                        _vm.getLevelOptions(type, level),
                                        function(option) {
                                          return _c(
                                            "div",
                                            {
                                              key: option.id,
                                              staticClass: "level-row"
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(option.name) + ":"
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "level-input-wrapper"
                                                },
                                                [
                                                  _c("custom-input", {
                                                    attrs: {
                                                      disabled: _vm.isReadOnly,
                                                      min: "0",
                                                      placeholder: "0",
                                                      type: "number",
                                                      value: option.other
                                                    },
                                                    on: {
                                                      input: newValue =>
                                                        _vm.handleLevelInput(
                                                          option,
                                                          newValue
                                                        )
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      errors[0]
                                        ? _c(
                                            "small",
                                            { staticClass: "level-error" },
                                            [
                                              _vm._v(
                                                " Debe completar al menos un campo del nivel con un valor mayor a 0. "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ])
              }),
              0
            ),
            _vm.getCommentOption(type)
              ? _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-text-area", {
                                  attrs: {
                                    "count-classes": [
                                      "d-block",
                                      "small-counter",
                                      "text-right"
                                    ],
                                    "custom-error-msg": "El campo es requerido",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    label: `${_vm.getCommentOption(type)
                                      ?.name ||
                                      "Interpretación de los resultados"}:`,
                                    maxlength: 5000,
                                    "show-char-count": !_vm.isReadOnly
                                  },
                                  model: {
                                    value: _vm.getCommentOption(type).other,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.getCommentOption(type),
                                        "other",
                                        $$v
                                      )
                                    },
                                    expression: "getCommentOption(type).other"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      }),
      _c("div", { staticClass: "total-box mt-3 mb-3" }, [
        _c("span", [
          _vm._v(
            " Tiempo total en segundos en el área de Lenguajes y Matemáticas: "
          )
        ]),
        _c("strong", [_vm._v(_vm._s(_vm.totalTime))])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }